<template>
  <div class="dashboard-container">
      <el-calendar v-model="date">
        <template slot="dateCell" slot-scope="{date, data}">
          <div :class="{ selected : isSelected(date, data) }" @click="handleClick(data)" @dblclick="dblClick(data)">
            <div class="solar">{{ data.day.split('-')[2] }}</div>
            <div class="lunar" :class="{ festival : isFestival(date, data) }">{{ solarToLunar(date, data) }}</div>
          </div>
        </template>
      </el-calendar>
  </div>
</template>
 
<script>
import calendar from '@/utils/canlendar.js'
  export default {
    name: 'Dashboard',
    props: {
      double:false,
    },
    data(){
      return{
        date: new Date(),
        // 根据selectedDates设置选中日期
        selectedDates: ['2020-04-12', '2020-04-15', '2020-04-24'],
        clickCount: 0,
        clickTimeout: null
      }
    },
    methods: {
      // 设置单选时间
      handleClick(data) {
        if (this.double) {
          this.clickCount++
          if (this.clickCount === 1) {
            this.clickTimeout = setTimeout(() => {
              this.$emit('handleOne', data)
              this.clickCount = 0
            },300)
          } 
        } else {
          this.$emit('handleOne', data)
        }
      },
      dblClick(data) {
        if (this.double) {
          this.clickCount = 0
          clearTimeout(this.clickTimeout)
          this.$emit('handleTwo',data)
        }
      },
      // 是否选中日期
      isSelected : function(slotDate, slotData) {
        return this.selectedDates.includes(slotData.day)
      },
      // 是否节假日
      isFestival(slotDate, slotData) {
        let solarDayArr = slotData.day.split('-');
        let lunarDay = calendar.solar2lunar(solarDayArr[0], solarDayArr[1], solarDayArr[2])
 
        // 公历节日\农历节日\农历节气
        let festAndTerm = [];
        festAndTerm.push(lunarDay.festival == null ? '' : ' ' + lunarDay.festival)
        festAndTerm.push(lunarDay.lunarFestival == null ? '' : '' + lunarDay.lunarFestival)
        festAndTerm.push(lunarDay.Term == null ? '' : '' + lunarDay.Term)
        festAndTerm = festAndTerm.join('')
 
        return festAndTerm != ''
      },
      // 公历转农历
      solarToLunar(slotDate, slotData) {
        let solarDayArr = slotData.day.split('-');
        let lunarDay = calendar.solar2lunar(solarDayArr[0], solarDayArr[1], solarDayArr[2])
 
        // 农历日期
        // let lunarMD = lunarDay.IMonthCn + lunarDay.IDayCn // 显示月份
        let lunarMD =  lunarDay.IDayCn // 显示日期
        // 公历节日\农历节日\农历节气
        let festAndTerm = [];
        festAndTerm.push(lunarDay.festival == null ? '' : ' ' + lunarDay.festival)
        festAndTerm.push(lunarDay.lunarFestival == null ? '' : '' + lunarDay.lunarFestival)
        festAndTerm.push(lunarDay.Term == null ? '' : '' + lunarDay.Term)
        festAndTerm = festAndTerm.join('')
        return festAndTerm == '' ? lunarMD : festAndTerm
      }
    }
  }
</script>
 
<style scoped>
  /**隐藏上一月、本月、下一月*/
  .el-calendar__button-group {
    display: none;
  }
  /**月份居中*/
  .el-calendar__title {
    width: 100%;
    text-align: center;
  }
  /**日期div的样式*/
  .el-calendar-table tr td:first-child {
    border-left: 0px;
  }
  /deep/ .el-calendar-table thead th {
    padding: 8px 0;
  }
  /deep/ .el-calendar-table td {
    box-sizing: border-box;
    border: none !important;
  }
  /deep/ .el-calendar-table td.is-selected {
    border-radius: 8px;
  }
  /deep/ .el-calendar-table .el-calendar-day {
    height: 100%;
    /* padding: 0px; */
    text-align: center;
    font-size: 12px;
    padding: 4px;
    border: 1px solid transparent;
  }
  .el-calendar-table .el-calendar-day > div {
    /* height: 84px; */
    text-align: center
  }
  /**日期div的样式-公历*/
  .el-calendar-table .el-calendar-day > div .solar {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
  }
  /**日期div的样式-农历*/
  .el-calendar-table .el-calendar-day > div .lunar {
    /* padding-top: 4px; */
    text-align: center;
    font-size: 10px;
    line-height: 14px;
  }
  /**日期div的样式-选中*/
  .el-calendar-table .el-calendar-day > div.selected {
    background-color: #fef2f2;
    border: 3px solid #fb0;
    border-radius: 20px;
    text-align: center
  }
 
  /**本月周末设置为红色*/
  .el-calendar-table .current:nth-last-child(-n+2) .solar {
    color:#bb0009;
  }
  /**本月农历设置为灰色*/
  .el-calendar-table .current .lunar {
    color: #606266;
  }
  /**本月农历节日设置为红色*/
  .el-calendar-table .current .lunar.festival {
    color:#bb0009;
  }

  /deep/ .el-calendar-table .el-calendar-day:hover {
    border: 1px solid #b40005;
    background-color: transparent;
    border-radius: 8px;
  }
  /deep/ .el-calendar-table td.is-today {
    border-radius: 8px;
  }
 /deep/.el-calendar {
    border-radius: 16px 16px 0 0;
  }
  /deep/ .el-calendar__body {
    padding: 12px 20px;
  }
  /**禁用点击效果*/
  /*.el-calendar-table td {*/
  /*pointer-events: none;*/
  /*}*/
</style>
 


// WEBPACK FOOTER //
// src/views/main/components/LunarCanlendar.vue